import "./index.0.css";
import { capitalize } from "lodash-es";
const __script_base__ = {
  name: 'WText',
  props: {
    type: {
      type: String,
      default: ''
    },
    align: {
      type: String,
      default: 'left'
    },
    text: {
      type: [String, Number],
      required: true
    }
  },
  beforeCreate() {
    this.isDesignMode = !!this.$attrs['data-uc-design-mode'];
  },
  computed: {
    extraClass() {
      const ans = [];
      if (this.type) ans.push(`is${capitalize(this.type)}`); // isHeading  isWarning ...
      ans.push(`align${capitalize(this.align)}`); // alignCenter alignRight
      return ans.join(' ');
    },
    finalText() {
      var _this$text;
      const text = String((_this$text = this.text) !== null && _this$text !== void 0 ? _this$text : '');
      if (this.isDesignMode && !text.trim()) return 'Lorem Ipsum'; // 设计模式下的空白占位
      return text;
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._g({
    staticClass: "w-text",
    class: _vm.extraClass,
    domProps: {
      textContent: _vm._s(_vm.finalText)
    }
  }, _vm.$listeners));
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Text/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);